import {
    SET_STATUS_DATA,
    GET_ADD_DATA_GROUP_USER,
    ALERT_MESSAGE_USER_MANAGE,
    GET_ALL_COMPANY,
    GET_POOL_COMPANY,
    GET_VEHICLE_COMPANY,
    GET_TRANSIT_COMPANY,
    GET_ALL_GROUP,
    GET_ADD_GROUP,
    GET_EDIT_GROUP,
    GET_DELETE_GROUP,
    GET_SET_USER_MANAGE,
    GET_VISITED_PAGE,
    SUCCESS_MESSAGE_MANAGE,
    ERROR_MESSAGE_MANAGE,
    HIDE_MESSAGE_MANAGE,
} from 'constants/ActionTypes';

let INIT_STATE = {
    alertMessageManage: '',
    successMessageManage: false,
    errorMessageManage: false,
    showMessage: false,
    errorMessage: '',
    dataUser: [],
    dataCompany: [],
    dataPool: [],
    dataVehicle: [],
    dataTransitpoint: [],
    visitedPage: {user_management: 0, packages_menu: 0}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADD_DATA_GROUP_USER: {
            return {
                 ...state,
                 dataUser: action.payload
            }
         }
        case GET_ALL_COMPANY: {
            return {
                ...state,
                dataCompany: action.payload
            }
        }
        case GET_POOL_COMPANY: {
            return {
                ...state,
                dataPool : action.payload
            }
        }
        case GET_VEHICLE_COMPANY: {
            return {
                ...state,
                dataVehicle: action.payload
            }
        }
        case GET_TRANSIT_COMPANY: {
            return {
                ...state,
                dataTransitpoint: action.payload
            }
        }
        case ALERT_MESSAGE_USER_MANAGE: {
            return {
                ...state,
                errorMessage: action.payload
            }
        }
        case GET_ALL_GROUP: {
            return {
                ...state,
                dataUser: action.payload
            }
        }
        case GET_ADD_GROUP: {
            return {
                ...state,
                dataUser: [...state.dataUser, action.payload]
            }
        }
        case GET_SET_USER_MANAGE: {
            return {
                ...state,
                dataUser: action.payload
            }
        }
        case GET_VISITED_PAGE: {
            return {
                ...state,
                visited: action.payload
            }
        }
        case SUCCESS_MESSAGE_MANAGE: {
            return {
                ...state,
                alertMessageManage: action.payload,
                successMessageManage: true,
            }
        }
        case ERROR_MESSAGE_MANAGE: {
            return {
                ...state,
                alertMessageManage: action.payload,
                errorMessageManage: true,
            }
        }
        case HIDE_MESSAGE_MANAGE: {
            return {
                ...state,
                alertMessageManage: '',
                errorMessageManage: false,
                successMessageManage: false,
            }
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/UserManage.js